import React from "react";
import moment from "moment";

/**
 * Replaces missing static slide (P11 gec/kbt, P13 sw) with live proposal fields.
 */
const ProposalExtraDynamicPage = ({ createdProposal, rowvalue }) => {
  const p = createdProposal || rowvalue;
  if (!p) return null;

  const validity = p.proposalValidity
    ? moment(p.proposalValidity).format("DD-MMM-YYYY")
    : "—";

  const rows = [
    { label: "Proposal name", value: p.proposalName },
    { label: "Location", value: p?.location?.name },
    { label: "Proposal validity", value: validity },
    {
      label: "Monthly fixed rental",
      value:
        p.monthlyRental != null
          ? `S$ ${Number(p.monthlyRental).toLocaleString()} + applicable taxes`
          : "—",
    },
    {
      label: "Contract term",
      value: p.contractTerm != null ? `${p.contractTerm} months` : "—",
    },
    {
      label: "Lock-in / Notice",
      value: `${p.lockInPeriod ?? "—"} mo lock-in / ${p.noticePeriod ?? "—"} mo notice`,
    },
    {
      label: "Notes to client",
      value: p.notesToClient || "—",
    },
  ];

  return (
    <div
      className="proposal-extra-dynamic"
      style={{
        margin: "20px 0",
        padding: "20px 24px",
        border: "1px solid #cfd6e6",
        borderRadius: "8px",
        backgroundColor: "#f8fafc",
        color: "#222631",
      }}
    >
      <h3
        style={{
          fontSize: "18px",
          marginBottom: "16px",
          fontWeight: 600,
        }}
      >
        Proposal details
      </h3>
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <tbody>
          {rows.map((row, i) => (
            <tr key={i}>
              <td
                style={{
                  padding: "10px 12px",
                  borderBottom: "1px solid #e2e8f0",
                  width: "38%",
                  verticalAlign: "top",
                  fontWeight: 500,
                }}
              >
                {row.label}
              </td>
              <td
                style={{
                  padding: "10px 12px",
                  borderBottom: "1px solid #e2e8f0",
                  whiteSpace: "pre-wrap",
                }}
              >
                {row.value ?? "—"}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ProposalExtraDynamicPage;
